export const formatCustomerLabel = (customer) => {
  return `${customer.name} / ${customer.street} ${customer.street_number} ${customer.zipcode} ${customer.city}`;
};
export const formatCustomerOrderLabel = (customer) => {
  return `${customer.number} / ${customer.name} / ${customer.street} ${customer.street_number} ${customer.zipcode} ${customer.city} ${customer.country}`;
};
